import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { poppins300, poppins600 } from 'theme/common.style';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { styled } from '@mui/system';
import CustomizedSteppers from 'modules/private/BuyerDashboard/CustomStepper';
import WelcomeBannerImage from 'assets/images/WelcomeBannerHousesearching.png';
import CounterOfferImg from 'assets/images/CounterOfferImage.png';
import StageTwoTimerCommenced from 'assets/images/StageTwoTimerCommenced.png';
import BuyerWinnerImage from 'assets/images/BuyerWinnerImage.png';
import CampaignPausedImage from 'assets/images/CampaignPausedImage.png';
import AiBannerStar from 'assets/svg/AiBannerStar.svg';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getApiCall, postApiCall, stageTwoView } from 'api/apiService';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import {
  BUYER_GETQUESTION,
  LOGGED_FROM,
  POST_BUYER_BANNER_CLOSE,
  REQUEST_SIGN_TEMPLATE,
  USER_MAIL_ID,
} from 'constant/app.config';
import PrivateOfferBanner from 'component/BannerComponents/BuyerBanners/PrivateOfferBanner';
import DepositPaymentRequestReceivedBanner from 'component/BannerComponents/BuyerBanners/DepositPaymentRequestReceivedBanner';
import DepositPaymentReceivedBannerBuyer from 'component/BannerComponents/BuyerBanners/DepositPaymentReceivedBannerBuyer';
import Step1ESignRequestReceived from 'component/BannerComponents/BuyerBanners/ESignBanners/Step1ESignRequestReceived';
import Step3ESignReceivedSignNowBannerBuyer from 'component/BannerComponents/BuyerBanners/ESignBanners/Step3ESignReceivedSignNowBannerBuyer';
import DepositPaymentDueBannerBuyer from 'component/BannerComponents/BuyerBanners/DepositPaymentDueBannerBuyer';
import DepositPaymentOverDueBannerBuyer from 'component/BannerComponents/BuyerBanners/DepositPaymentOverDueBannerBuyer';
import ExchangeCompletedBannerBuyer from 'component/BannerComponents/BuyerBanners/ExchangeCompletedBannerBuyer';
import SettlementCompletedBannerBuyer from 'component/BannerComponents/BuyerBanners/SettlementCompletedBannerBuyer';
import Step2ESignRequestPreparing from 'component/BannerComponents/BuyerBanners/ESignBanners/Step2ESignRequestPreparing';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { toast } from 'react-toastify';
import 'swiper/swiper-bundle.min.css';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import CommenceESignDialog from './CommenceESignDialog';
import PrivateOfferDetails from 'component/BuyerRegistration/PrivateOfferDetails';
import BannerMoreInfoDialog from 'component/BannerComponents/BannerMoreInfoDialog';
SwiperCore.use([Autoplay, Pagination, Navigation]);

const ViewEyeIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159778)">
        <path
          d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 12C19.333 16.667 16 19 12 19C8 19 4.667 16.667 2 12C4.667 7.333 8 5 12 5C16 5 19.333 7.333 22 12Z"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159778">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const SignNowIcon = ({ disableColor }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 28 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 25C6.09753 22 8.64706 19 8.64706 16C8.64706 11.5 7.11765 11.5 5.58824 11.5C4.05882 11.5 2.48047 13.1275 2.52941 16C2.58141 19.072 5.06518 20.3155 6.35294 22C8.64706 25 10.1765 25.75 11.7059 23.5C12.726 22 13.4907 20.7505 14 19.75C15.5294 23.2495 17.5681 25 20.1176 25H23.9412"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.0005 22V4C27.0005 2.3185 25.6561 1 23.9416 1C22.2272 1 20.8828 2.3185 20.8828 4V22L23.9416 25L27.0005 22Z"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.8828 7H27.0005"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DepositIcon = ({ disableColor }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      style={{ borderRadius: '20px' }}
      fill={disableColor ? '#C2C2C2' : '#2184FD'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
      />
      <path
        d="M14.8464 23.6927C17.1926 23.6927 19.4427 22.7607 21.1017 21.1017C22.7607 19.4427 23.6927 17.1926 23.6927 14.8464C23.6927 12.5002 22.7607 10.2501 21.1017 8.59104C19.4427 6.93203 17.1926 6 14.8464 6C12.5002 6 10.2501 6.93203 8.59104 8.59104C6.93203 10.2501 6 12.5002 6 14.8464C6 17.1926 6.93203 19.4427 8.59104 21.1017C10.2501 22.7607 12.5002 23.6927 14.8464 23.6927Z"
        fill="none"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1479 8.21161V21.4812"
        fill="none"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.1638 10.6242H13.6401C13.0802 10.6242 12.5432 10.8467 12.1473 11.2426C11.7514 11.6385 11.529 12.1754 11.529 12.7353C11.529 13.2952 11.7514 13.8322 12.1473 14.2281C12.5432 14.624 13.0802 14.8464 13.6401 14.8464H16.6559C17.2158 14.8464 17.7527 15.0688 18.1486 15.4647C18.5445 15.8606 18.7669 16.3975 18.7669 16.9574C18.7669 17.5173 18.5445 18.0543 18.1486 18.4502C17.7527 18.8461 17.2158 19.0685 16.6559 19.0685H11.529"
        fill="none"
        stroke={disableColor ? '#C2C2C2' : '#2184FD'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ConfirmTicIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159899)">
        <path
          d="M5 12L10 17L20 7"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159899">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const NextStepArrow = () => {
  return (
    <svg
      width="19"
      height="8"
      viewBox="0 0 19 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3536 4.35355C18.5488 4.15829 18.5488 3.84171 18.3536 3.64645L15.1716 0.464466C14.9763 0.269204 14.6597 0.269204 14.4645 0.464466C14.2692 0.659728 14.2692 0.976311 14.4645 1.17157L17.2929 4L14.4645 6.82843C14.2692 7.02369 14.2692 7.34027 14.4645 7.53553C14.6597 7.7308 14.9763 7.7308 15.1716 7.53553L18.3536 4.35355ZM0 4.5L18 4.5V3.5L0 3.5L0 4.5Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
const WelcomeBannerFlag = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159755)">
        <path
          d="M4 17V22H2V3H21.138C21.2256 2.99985 21.3118 3.02275 21.3878 3.06639C21.4638 3.11002 21.527 3.17288 21.5711 3.24864C21.6151 3.3244 21.6385 3.41042 21.6388 3.49806C21.6392 3.5857 21.6165 3.6719 21.573 3.748L18 10L21.573 16.252C21.6165 16.3281 21.6392 16.4143 21.6388 16.5019C21.6385 16.5896 21.6151 16.6756 21.5711 16.7514C21.527 16.8271 21.4638 16.89 21.3878 16.9336C21.3118 16.9773 21.2256 17.0001 21.138 17H4ZM4 5V15H18.554L15.696 10L18.554 5H4Z"
          fill="#2184FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159755">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const Message = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159803)">
        <path
          d="M22.5 1.49023H1.5C0.671625 1.49023 0 2.16186 0 2.99023V16.5255C0 17.3539 0.671625 18.0255 1.5 18.0255H4.48912V21.7594C4.48907 21.9072 4.53272 22.0517 4.6146 22.1747C4.69647 22.2978 4.8129 22.3938 4.94925 22.4509C5.04103 22.4894 5.13956 22.5093 5.2391 22.5094C5.43583 22.5095 5.62471 22.4322 5.76485 22.2941L10.1014 18.0255H22.5C23.3283 18.0255 24 17.3539 24 16.5255V2.99023C24 2.16188 23.3283 1.49023 22.5 1.49023ZM22.5 16.5251H9.48713L5.98912 19.9684V16.5251H1.5V2.99023H22.5V16.5251ZM5.25 10.5232H18.75C19.164 10.5232 19.5 10.1872 19.5 9.77323C19.5 9.35923 19.164 9.02323 18.75 9.02323H5.25C4.836 9.02323 4.5 9.35923 4.5 9.77323C4.5 10.1872 4.836 10.5232 5.25 10.5232ZM5.25 7.52323H18.75C19.164 7.52323 19.5 7.18723 19.5 6.77323C19.5 6.35923 19.164 6.02323 18.75 6.02323H5.25C4.836 6.02323 4.5 6.35923 4.5 6.77323C4.5 7.18723 4.836 7.52323 5.25 7.52323ZM5.25 13.5232H14.25C14.664 13.5232 15 13.1872 15 12.7732C15 12.3592 14.664 12.0232 14.25 12.0232H5.25C4.836 12.0232 4.5 12.3592 4.5 12.7732C4.5 13.1872 4.836 13.5232 5.25 13.5232Z"
          fill="#4898F8"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159803">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const AiBannerRectangle = ({ matchessm, matchesmd }) => {
  return (
    <svg
      width={matchesmd ? '50' : '126'}
      height={matchesmd ? '50' : '126'}
      viewBox="0 0 126 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2101_2)">
        <path
          d="M123 3H3V123H123V3Z"
          stroke="url(#paint0_linear_2101_2)"
          stroke-width="6"
        />
        <path
          d="M66.542 86L63.5882 77.1101H45.7341L42.7803 86H33L49.2131 38.4968H60.1749L76.3223 86H66.542ZM48.1628 69.781H61.2252L54.6612 50.0333L48.1628 69.781ZM93 38.8361C93 40.4648 92.453 41.8446 91.359 42.9757C90.265 44.1067 88.9303 44.6722 87.355 44.6722C85.8234 44.6722 84.5106 44.1067 83.4166 42.9757C82.3225 41.8446 81.7756 40.4648 81.7756 38.8361C81.7756 37.2074 82.3225 35.8276 83.4166 34.6965C84.5106 33.5655 85.8234 33 87.355 33C88.9303 33 90.265 33.5655 91.359 34.6965C92.453 35.8276 93 37.2074 93 38.8361ZM82.7602 86V48.4046H92.0154V86H82.7602Z"
          fill="url(#paint1_linear_2101_2)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2101_2"
          x1="17.6842"
          y1="-76.9999"
          x2="185.591"
          y2="126.429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2101_2"
          x1="40.7685"
          y1="-57.3226"
          x2="183.707"
          y2="44.7775"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#6C2AD2" />
          <stop offset="1" stop-color="#77CFFE" />
        </linearGradient>
        <clipPath id="clip0_2101_2">
          <rect width="126" height="126" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const BuyerIndividualBanners = (props) => {
  const {
    setTabDAta,
    isStickyTimerStage,
    stickyAnchorTimerRef,
    getBuyerIndividualValue,
    isStickyAddress,
    setIsHovered,
    isHovered,
    isSticky,
    showActivateTrade,
    sharedpage,
    setOpenlogin,
    openlogin,
    handleMouseLeave,
    handleClick,
    isDialogOpen,
    setDialogOpen,
    anchorEl,
    setAnchorEl,
    PropertyId,
    scrollToChecklistRef,
    groupIt,
    groupCall,
    st1condition,
    setOpensolicitorpopup,
    setTypeofsolicitorpopup,
  } = props;

  const currentPage = window.location.pathname;
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);

  const [buyerBinderID, setBuyerBinderID] = useState('');
  // temporary state to store closed banners for counter offers, AI monitor,
  const [aiBannerClose, setAiBannerClose] = useState([]);
  const [closedCounterOffers, setClosedCounterOffers] = useState([]);
  // API call close banner
  const [depostPaymentReceviedClose, setDepostPaymentReceviedClose] = useState(
    []
  );
  const [
    depostPaymentRequestReceviedClose,
    setDepostPaymentRequestReceviedClose,
  ] = useState([]);
  const [exchangeCompleteClose, setExchangeCompleteClose] = useState([]);
  const [privateOfferClose, setPrivateOfferClose] = useState([]);
  const [settlementbannerClose, setSettlementbannerClose] = useState([]);
  const [esignRequestRecBanner, setEsignRequestRecBanner] = useState([]);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  // Set this to match your `winnerAt` timezone
  const SYDNEY_TZ = 'Australia/Sydney';

  // true if within 1 hour after winnerAt
  const isWithinOneHour = (winnerAtStr) => {
    const winnerAt = dayjs.tz(winnerAtStr, SYDNEY_TZ);
    return dayjs().isBefore(winnerAt.add(1, 'hour'));
  };

  // true if more than 1 hour has passed since winnerAt
  const isAfterOneHour = (winnerAtStr) => {
    const winnerAt = dayjs.tz(winnerAtStr, SYDNEY_TZ);
    return dayjs().isAfter(winnerAt.add(1, 'hour'));
  };

  const [manageOffer, setManageOffer] = useState(false);
  const [privateOfferDetailsOpen, setPrivateOfferDetailsOpen] = useState(false);
  const [manageOfferDatas, setManageOfferDatas] = useState({});

  const manageOfferClickClose = () => {
    setManageOffer(false);
  };

  const [isBuyerDashboardView, setIsBuyerDashboardView] = useState(false);
  const [viewBuyerHistory, setViewBuyerHistory] = useState(false);

  const handleScrollToOfferHistory = () => {
    setViewBuyerHistory(true);
  };

  const history = useHistory();
  const location = useLocation();

  const { dashboardPrivateOfferView } = location?.state || {};

  useEffect(() => {
    if (dashboardPrivateOfferView) {
      setIsBuyerDashboardView(true);
      history.push({
        pathname: history?.location?.pathname,
        state: { propertyIds: true, dashboardPrivateOfferView: false },
      });
    }
  }, [dashboardPrivateOfferView]);

  const swiperRef = useRef(null);

  const [currentExchangeIndex, setCurrentExchangeIndex] = useState(0);
  const [pauseBuyerExchangeBanner, setPauseBuyerExchangeBanner] =
    useState(true);

  useEffect(() => {
    let buyerExchangeTimer;

    if (currentExchangeIndex) {
      buyerExchangeTimer = setTimeout(() => {
        setPauseBuyerExchangeBanner(true);
        setCurrentExchangeIndex(false);
      }, 10000);
    } else {
      setPauseBuyerExchangeBanner(false);
    }

    return () => {
      if (buyerExchangeTimer) clearTimeout(buyerExchangeTimer);
    };
  }, [currentExchangeIndex]);

  return (
    <>
      <Swiper
        ref={swiperRef}
        onMouseEnter={() => swiperRef?.current?.swiper?.autoplay?.stop()}
        onMouseLeave={() => swiperRef?.current?.swiper?.autoplay?.start()}
        onSlideChange={(swiper) => {
          const activeSlideId = swiper.slides[swiper.activeIndex].id;
          setCurrentExchangeIndex(
            activeSlideId === 'Exchange_Complete_Buyer_Banner'
          );
        }}
        spaceBetween={30}
        slidesPerView={1}
        centeredSlides={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5,
        }}
        className="product-carousel-wrapper"
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        style={{
          marginTop: '20px',
          position: 'relative',
          overflow: 'visible',
          paddingBottom: '5px',
        }}
      >
        <div
          style={{
            position: isStickyTimerStage && 'fixed',
            top: isStickyTimerStage && '150px',
            width: isStickyTimerStage && '60%',
            zIndex: 10000,
          }}
          ref={stickyAnchorTimerRef}
        >
          {getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status ==
            'Counter Received' &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.timerStatus !== 'End' &&
            getBuyerIndividualValue?.PropertyDetails?.stage !== 'ST2' &&
            !closedCounterOffers.includes(
              getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
            ) &&
            !currentPage.includes('/share') && (
              <SwiperSlide>
                <CounterOfferReceivedBanner
                  setTabDAta={setTabDAta}
                  scrollToChecklistRef={scrollToChecklistRef}
                  groupIt={groupIt}
                  groupCall={groupCall}
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  propertyId={
                    getBuyerIndividualValue?.PropertyDetails?.property
                      ?.propertyId
                  }
                  setClosedCounterOffers={setClosedCounterOffers}
                  setOpensolicitorpopup={setOpensolicitorpopup}
                  setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                />
              </SwiperSlide>
            )}
          {getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause' &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            !currentPage.includes('/share') && (
              <SwiperSlide>
                <CampaignPausedBanner
                  isStickyAddress={isStickyAddress}
                  setIsHovered={setIsHovered}
                  isHovered={isHovered}
                  isSticky={isSticky}
                  showActivateTrade={showActivateTrade}
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  sharedpage={sharedpage}
                  setOpenlogin={setOpenlogin}
                  openlogin={openlogin}
                  handleMouseLeave={handleMouseLeave}
                  handleClick={handleClick}
                  isDialogOpen={isDialogOpen}
                  setDialogOpen={setDialogOpen}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                />
              </SwiperSlide>
            )}
          {!currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isFirstOfferAccepted ==
              1 &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.stage !== 'ST2' &&
            getBuyerIndividualValue?.PropertyDetails?.timerStatus !== 'End' &&
            getBuyerIndividualValue?.PropertyDetails?.isMyOfferAccepted == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.flagReadySign === 0 &&
            !aiBannerClose.includes(
              getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
            ) && (
              <SwiperSlide>
                <AiMonitorBanner
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  setAiBannerClose={setAiBannerClose}
                  st1condition={st1condition}
                  groupIt={groupIt}
                  PropertyID={
                    getBuyerIndividualValue?.PropertyDetails?.property
                      ?.propertyId
                  }
                />
              </SwiperSlide>
            )}
          {!privateOfferClose.includes(
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          ) &&
            !currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isPrivateClosed == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.stage !== 'ST2' &&
            getBuyerIndividualValue?.PropertyDetails?.privateOfferStatus ==
              'Received' && (
              <SwiperSlide>
                <PrivateOfferBanner
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                  setManageOffer={setManageOffer}
                  setPrivateOfferClose={setPrivateOfferClose}
                />
              </SwiperSlide>
            )}

          {getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
            userDetail?.userId &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            !currentPage.includes('/share') && (
              <SwiperSlide
                style={{ textAlign: 'none !important', borderRadius: '20px' }}
              >
                <CongratulationsBanner
                  depositPaymentStatus={
                    getBuyerIndividualValue?.PropertyDetails
                      ?.flagDepositPaymentStatus
                  }
                  signVal={
                    getBuyerIndividualValue?.PropertyDetails?.contractSignStatus
                  }
                  isWinnerloc={
                    getBuyerIndividualValue?.PropertyDetails?.streetName
                  }
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  PropertyId={PropertyId}
                  setBuyerBinderID={setBuyerBinderID}
                  groupCall={groupCall}
                />
              </SwiperSlide>
            )}
          {!esignRequestRecBanner.includes(
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          ) &&
            !currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinner == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.flagSignContractStatus ==
              'Pending Buyer Signature' &&
            getBuyerIndividualValue?.PropertyDetails
              ?.isTodayContractBannerViewed == 0 && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <Step1ESignRequestReceived
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupCall={groupCall}
                  setEsignRequestRecBanner={setEsignRequestRecBanner}
                />
              </SwiperSlide>
            )}
          {!currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinner == 1 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
              userDetail?.userId &&
            getBuyerIndividualValue?.PropertyDetails?.flagSignContractStatus !==
              'Pending Buyer Signature' &&
            getBuyerIndividualValue?.PropertyDetails?.flagSignContractStatus !==
              'Completed' && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <Step2ESignRequestPreparing
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                />
              </SwiperSlide>
            )}
          {!currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinner == 1 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
              userDetail?.userId &&
            getBuyerIndividualValue?.PropertyDetails?.flagSignContractStatus ==
              'Pending Buyer Signature' && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <Step3ESignReceivedSignNowBannerBuyer
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupCall={groupCall}
                />
              </SwiperSlide>
            )}
          {!depostPaymentRequestReceviedClose.includes(
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          ) &&
            !currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails
              ?.flagDepositPaymentStatus == 'Action Required' &&
            getBuyerIndividualValue?.PropertyDetails?.isDepositReceived !== 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinner == 0 &&
            getBuyerIndividualValue?.PropertyDetails
              ?.isTodayDepositPaymentViewed == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.flagDepositPayment ==
              0 && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <DepositPaymentRequestReceivedBanner
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                  setDepostPaymentRequestReceviedClose={
                    setDepostPaymentRequestReceviedClose
                  }
                />
              </SwiperSlide>
            )}
          {!currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinner == 1 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
              userDetail?.userId &&
            getBuyerIndividualValue?.PropertyDetails?.isDepositReceived !== 0 &&
            getBuyerIndividualValue?.PropertyDetails?.flagDepositPayment == 0 &&
            isWithinOneHour(
              getBuyerIndividualValue?.PropertyDetails?.winnerAt
            ) && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <DepositPaymentDueBannerBuyer
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                />
              </SwiperSlide>
            )}
          {!currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinner == 1 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
              userDetail?.userId &&
            getBuyerIndividualValue?.PropertyDetails
              ?.flagDepositPaymentStatus !== 'Completed' &&
            isAfterOneHour(
              getBuyerIndividualValue?.PropertyDetails?.winnerAt
            ) && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <DepositPaymentOverDueBannerBuyer
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                />
              </SwiperSlide>
            )}
          {!depostPaymentReceviedClose.includes(
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          ) &&
            !currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.flagDepositPayment == 1 &&
            getBuyerIndividualValue?.PropertyDetails
              ?.isTodayDepositConfirmedViewed == 0 && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <DepositPaymentReceivedBannerBuyer
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                  setDepostPaymentReceviedClose={setDepostPaymentReceviedClose}
                />
              </SwiperSlide>
            )}
          {!exchangeCompleteClose.includes(
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          ) &&
            !currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.isPropertyArchived == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.propertyExchangedStatus ==
              'Exchanged' &&
            getBuyerIndividualValue?.PropertyDetails?.isExchangedClosed == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
              userDetail?.userId && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
                id={'Exchange_Complete_Buyer_Banner'}
              >
                <ExchangeCompletedBannerBuyer
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                  pauseBuyerExchangeBanner={pauseBuyerExchangeBanner}
                  setExchangeCompleteClose={setExchangeCompleteClose}
                />
              </SwiperSlide>
            )}
          {!settlementbannerClose.includes(
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          ) &&
            !currentPage.includes('/share') &&
            getBuyerIndividualValue?.PropertyDetails?.propertyExchangedStatus ==
              'Settlement' &&
            getBuyerIndividualValue?.PropertyDetails?.isSettlementClosed == 0 &&
            getBuyerIndividualValue?.PropertyDetails?.isWinnerId ===
              userDetail?.userId && (
              <SwiperSlide
                style={{
                  textAlign: 'none !important',
                  borderRadius: '20px',
                }}
              >
                <SettlementCompletedBannerBuyer
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                  setSettlementbannerClose={setSettlementbannerClose}
                />
              </SwiperSlide>
            )}
        </div>
      </Swiper>
      {(manageOffer || isBuyerDashboardView) && (
        <ManageOffer
          open={manageOffer || isBuyerDashboardView}
          onClose={manageOfferClickClose}
          propertyId={
            getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          }
          getBuyerIndividualValue={getBuyerIndividualValue}
          groupIt={groupIt}
          groupCall={groupCall}
          moxouserId={true}
          viewBuyerHistory={viewBuyerHistory}
          setViewBuyerHistory={setViewBuyerHistory}
          handleScrollToOfferHistory={handleScrollToOfferHistory}
          setIsBuyerDashboardView={setIsBuyerDashboardView}
          isBannerView={true}
          setManageOffer={setManageOffer}
          setPrivateOfferDetailsOpen={setPrivateOfferDetailsOpen}
          setManageOfferDatas={setManageOfferDatas}
          setOpensolicitorpopup={setOpensolicitorpopup}
          setTypeofsolicitorpopup={setTypeofsolicitorpopup}
        />
      )}

      {/* Add PrivateOfferDetails component */}
      <PrivateOfferDetails
        open={privateOfferDetailsOpen}
        setPrivateOfferDetailsOpen={setPrivateOfferDetailsOpen}
        setBuyeracceptcounter={setViewBuyerHistory}
        getBuyerIndividualValue={getBuyerIndividualValue}
        manageOfferData={manageOfferDatas}
        tableData={{}}
        propertyDetails={{}}
        setManageOffer={setManageOffer}
        groupIt={groupIt}
        groupCall={groupCall}
        getListInfo={groupCall}
        setManageOfferDatas={setManageOfferDatas}
        setManageOfferss={setManageOffer}
        setIsBuyerDashboardView={setIsBuyerDashboardView}
        setOpensolicitorpopup={setOpensolicitorpopup}
        setTypeofsolicitorpopup={setTypeofsolicitorpopup}
      />
    </>
  );
};

export const StageTwoTimerCommencedBanner = (props) => {
  const {
    getBuyerIndividualValue,
    hoverEffect,
    buyerDashboardDetails,
    isBuyerDashboard,
    buyerFunction,
    groupIt,
  } = props;
  const theme = useTheme();

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const [stageLoader, setStageLoader] = useState(false);
  const params = useParams();

  const stageTwoViewFunc = () => {
    setStageLoader(true);
    const input = {
      propertyId: buyerDashboardDetails
        ? buyerDashboardDetails?.property?.propertyId
        : params?.propertyId,
      status: 'Accepted',
      isAccept: 1,
      isAcceptancePopup: 0,
    };
    stageTwoView(input).then((res) => {
      if (res?.status == 1) {
        setStageLoader(false);
        if (!isBuyerDashboard) {
          groupIt();
        }
        if (isBuyerDashboard) {
          buyerFunction();
        }
      } else {
        setStageLoader(false);
      }
    });
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 1 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={9} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 1 : 0.6,
                }}
              >
                {/* Property Address */}
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    textDecoration: 'none',
                    marginTop: '-20px',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>

                {/* Header Title */}
                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '18px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                    mt: 1,
                  }}
                >
                  Stage 2 Timer Commenced
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    fontFamily: 'poppins',
                    fontWeight: 300,
                    mt: 1.5,
                    color: '#FFF',
                  }}
                >
                  You are invited to participate in Stage 2 for{' '}
                  <Typography
                    component="span"
                    sx={{
                      color: '#FFF',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName ||
                      buyerDashboardDetails?.propertyAddress?.streetName}
                  </Typography>
                  .<br />
                  The campaign timer is now in the final stage. This is your
                  opportunity to win the property.
                </Typography>

                {/* Action Buttons */}
                <Stack
                  direction="row"
                  spacing={2}
                  mt={2.5}
                  alignItems="center"
                  flexWrap="wrap"
                  justifyContent={matchessm && 'space-between'}
                >
                  <Button
                    disabled={stageLoader}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      fontFamily: 'poppins',
                      fontWeight: 300,
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Terms
                  </Button>

                  <Box display="flex" alignItems="center">
                    <Button
                      disabled={stageLoader}
                      onClick={stageTwoViewFunc}
                      startIcon={<ConfirmTicIcon />}
                      sx={{
                        px: 4,
                        height: matchessm ? 35 : 42,
                        borderRadius: '5px',
                        fontSize: matchessm ? '12px' : '14px',
                        textTransform: 'none',
                        border: '1px solid #E6F2FF',
                        backgroundColor: '#FFF',
                        color: '#2184FD',
                        fontWeight: hoverEffect ? 500 : 400,
                        fontFamily: 'poppins',
                        '&:hover': {
                          bgcolor: '#FFF',
                          color: 'rgb(33, 132, 253)',
                        },
                      }}
                    >
                      Confirm
                    </Button>

                    {stageLoader && (
                      <CircularProgress
                        size={30}
                        sx={{ color: 'white', ml: 2 }}
                      />
                    )}
                  </Box>
                </Stack>
              </Box>
            </Grid>

            {/* Right Image */}
            <Grid
              item
              xs={12}
              md={3}
              display={matchessm ? 'none' : 'block'}
              textAlign="center"
              mt={2}
            >
              <img
                src={StageTwoTimerCommenced}
                alt="Stage Two Timer Commenced"
                style={{ objectFit: 'contain', height: '235px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export const CounterOfferReceivedBanner = (props) => {
  const {
    setTabDAta,
    propertyId,
    isBuyerDashboard,
    buyerDashboardDetails,
    scrollToChecklistRef,
    getBuyerIndividualValue,
    groupIt,
    setClosedCounterOffers,
    groupCall,
    setOpensolicitorpopup,
    setTypeofsolicitorpopup,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();

  const { isBuyerDashboardManageOffer, dashboardCounterOfferView } =
    location.state || {};
  const [isBuyerDashboardView, setIsBuyerDashboardView] = useState(false);

  useEffect(() => {
    if (
      isBuyerDashboardManageOffer &&
      getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status ==
        'Counter Received'
    ) {
      setIsBuyerDashboardView(true);
    }
  }, []);

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  const [manageOffer, setManageOffer] = useState(false);
  const [viewBuyerHistory, setViewBuyerHistory] = useState(false);

  const onPropertyClick = (propertyId) => {
    history.push({
      pathname: `market/${propertyId}`,
      state: {
        propertyIds: true,
        dashboardCounterOfferView: true,
        isBuyerDashboardManageOffer: true,
      },
    });
  };

  const manageOfferClickClose = () => {
    setManageOffer(false);
  };

  const handleScrollToOfferHistory = () => {
    setViewBuyerHistory(true);
  };

  const [autoScrollEnabled, setAutoScrollEnabled] = useState(false);

  const manageOfferClick = () => {
    setManageOffer(true);
  };

  useEffect(() => {
    if (dashboardCounterOfferView) {
      setManageOffer(true);
      history.push({
        pathname: history?.location?.pathname,
        state: { propertyIds: true, dashboardCounterOfferView: false },
      });
    }
  }, [dashboardCounterOfferView]);

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: 'rgba(33, 132, 253, 0.8)',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '15px' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container spacing={2}>
          <Grid
            xs={12}
            md={8.4}
            lg={9}
            mt={matchessm ? '10px' : '40px'}
            padding={matchessm ? '26px 2px 10px 26px' : '2px 40px 15px 40px'}
            height={'100%'}
          >
            <Box
              sx={{
                color: '#FFF',
                fontWeight: 300,
                fontSize: matchessm ? '14px' : '16px',
                textDecoration: 'none',
                fontFamily: 'poppins',
                marginBottom: '5px',
              }}
            >
              {isBuyerDashboard
                ? buyerDashboardDetails?.propertyAddress?.streetName
                : getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName}
            </Box>
            <Typography
              sx={{
                fontSize: !matches450 ? '32px' : '20px',
                fontWeight: 600,
                color: '#FFFFFF',
                fontFamily: 'poppins',
              }}
            >
              Counter Offer Received
            </Typography>
            <Box
              sx={{
                fontSize: matchessm ? '12px !important' : '16px',
                ...poppins300,
                fontStyle: 'normal !important',
                color: 'rgba(255, 255, 255, 1)',
                marginTop: '15px',
              }}
            >
              <Typography sx={{ fontFamily: 'poppins' }}>
                You have received a Counter Offer from the Vendor for
                <span
                  style={{
                    alignItems: 'center',
                  }}
                >
                  &nbsp;
                  <Typography
                    sx={{
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: 600,
                      fontSize: matchessm ? '15px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {isBuyerDashboard
                      ? buyerDashboardDetails?.propertyAddress?.streetName
                      : getBuyerIndividualValue?.PropertyDetails
                          ?.propertyAddress?.streetName}
                  </Typography>
                </span>{' '}
                This Counter Offer may have been shared with other buyers who
                are interested.
              </Typography>
            </Box>
            <Grid xs={12} md={4.5} mt={matchessm ? '20px' : '30px'}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent={matchessm ? 'space-between' : 'start'}
              >
                <Button
                  onClick={() => {
                    setClosedCounterOffers((prev) => [...prev, propertyId]);
                  }}
                  sx={{
                    padding: '2px 20px',
                    width: '125px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: 'transparent',
                    color: '#E6F2FF',
                    '&:hover': {
                      bgcolor: 'rgb(33, 132, 253)',
                      color: '#E6F2FF',
                    },
                  }}
                >
                  Ignore
                </Button>
                <Button
                  onClick={() => {
                    if (isBuyerDashboard) {
                      onPropertyClick(propertyId);
                    } else {
                      manageOfferClick();
                    }
                  }}
                  startIcon={<ViewEyeIcon />}
                  style={{
                    padding: '2px 20px',
                    width: '125px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: '#FFFFFF',
                    color: '#2184FD',
                  }}
                >
                  View
                </Button>
                <ManageOffer
                  open={isBuyerDashboardView || manageOffer}
                  onClose={manageOfferClickClose}
                  propertyId={propertyId}
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  groupIt={groupIt}
                  groupCall={groupCall}
                  moxouserId={true}
                  viewBuyerHistory={viewBuyerHistory}
                  setViewBuyerHistory={setViewBuyerHistory}
                  handleScrollToOfferHistory={handleScrollToOfferHistory}
                  autoScrollEnabled={autoScrollEnabled}
                  setAutoScrollEnabled={setAutoScrollEnabled}
                  setTabDAta={setTabDAta}
                  setIsBuyerDashboardView={setIsBuyerDashboardView}
                  isBannerView={true}
                  setManageOffer={setManageOffer}
                  setOpensolicitorpopup={setOpensolicitorpopup}
                  setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                />
              </Stack>
            </Grid>
          </Grid>
          <Grid
            xs={12}
            md={3.1}
            lg={3}
            display={matchessm ? 'none' : 'block'}
            mt={matchessm ? '10px' : '40px'}
            textAlign={'center'}
          >
            <img src={CounterOfferImg} alt="offer-received" />
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export const CampaignPausedBanner = ({
  isStickyAddress,
  isSticky,
  showActivateTrade,
  getBuyerIndividualValue,
  sharedpage,
  buyerDashboardAgentDetails,
  isBuyerDashboard,
  buyerDashboardDetails,
}) => {
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const { setShowMessage, setMessagedata } = useContext(datacontext);
  const [openlogin, setOpenlogin] = useState(false);

  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  };
  const onOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: 'rgba(33, 132, 253, 0.8)',
          width: '100%',
          borderRadius: '20px',
          padding: matchessm ? '20px' : '10px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
        }}
      >
        <Grid container spacing={2}>
          <Grid
            xs={12}
            md={8.4}
            lg={9}
            mt={matchessm ? '30px' : '40px'}
            padding={matchessm ? '0px 20px' : '15px 40px'}
            height={'100%'}
          >
            <Box
              sx={{
                color: '#FFF',
                fontWeight: 300,
                fontSize: matchessm ? '14px' : '16px',
                fontFamily: 'poppins',
                textDecoration: 'none',
                marginBottom: '5px',
              }}
            >
              {isBuyerDashboard
                ? buyerDashboardDetails?.propertyAddress?.streetName
                : getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName}
            </Box>
            <Typography
              sx={{
                fontSize: !matches450 ? '32px' : '20px',
                fontWeight: 600,
                color: 'rgba(255, 255, 255, 1)',
                fontFamily: 'poppins',
              }}
            >
              Campaign Paused
            </Typography>
            <Box
              sx={{
                fontSize: matchessm ? '14px' : '16px',
                ...poppins300,
                fontStyle: 'normal',
                color: 'rgba(255, 255, 255, 1)',
                marginTop: '15px',
                fontFamily: 'poppins',
                lineHeight: 'normal',
              }}
            >
              The campaign for{' '}
              <Box
                component="span"
                sx={{
                  color: 'rgba(255, 255, 255, 1)',
                  fontWeight: matchessm ? 600 : 700,
                  fontSize: matchessm ? '14px' : '16px',
                  fontFamily: 'poppins',
                  textTransform: 'capitalize',
                  display: 'inline',
                }}
              >
                {isBuyerDashboard
                  ? buyerDashboardDetails?.propertyAddress?.streetName
                  : getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName}
              </Box>{' '}
              has been paused temporarily. You will be notified once the
              campaign resumes. For more information please contact the agent.
            </Box>
            <Grid xs={12} md={4.5} mt={matchessm ? '35px' : '30px'}>
              <Stack direction="row" spacing={2}>
                <Button
                  onClick={onOpen}
                  sx={{
                    padding: '5px 20px',
                    width: '126px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: 'transparent',
                    color: '#E6F2FF',
                    '&:hover': {
                      bgcolor: 'rgb(33, 132, 253)',
                      color: '#E6F2FF',
                    },
                  }}
                >
                  More Info
                </Button>
                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    if (sharedpage) {
                      setOpenlogin(!openlogin);
                    } else {
                      localStorage.setItem(
                        'dialId',
                        getBuyerIndividualValue?.PropertyDetails?.agentDetails
                          ?.agentEmail
                      );
                      setShowMessage(true);
                      setMessagedata({ incomingcall: true });
                    }
                  }}
                  startIcon={<Message size={matchessm ? 18 : 24} />}
                  style={{
                    padding: '5px 4px',
                    width: matchessm ? '160px' : '172px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: matchessm ? '12px' : '14px',
                    textTransform: 'none',
                    border: '1px solid #E6F2FF',
                    backgroundColor: '#FFFFFF',
                    color: '#2184FD',
                  }}
                >
                  Contact Agent
                </Button>
              </Stack>
            </Grid>
          </Grid>
          <Grid
            xs={12}
            md={3.1}
            lg={3}
            display={matchessm ? 'none' : 'block'}
            mt={matchessm ? '10px' : '40px'}
            textAlign={'center'}
          >
            <img
              src={CampaignPausedImage}
              height={'235px'}
              alt="offer-received"
            />
          </Grid>
        </Grid>
      </Card>
      <BannerMoreInfoDialog
        open={open}
        onClose={onClose}
        status={'CAMPAIGN_PAUSED'}
      />
    </>
  );
};
export const AiMonitorBanner = (props) => {
  const {
    isBuyerDashboard,
    PropertyID,
    buyerDashboardDetails,
    getBuyerIndividualValue,
    setAiBannerClose,
    st1condition,
    groupIt,
    DashboardGroupCall,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches1300 = useMediaQuery(theme.breakpoints.down(1300));

  const IDVerificationClick = () => {
    if (isBuyerDashboard) {
      history.push({
        pathname: `market/${PropertyID}`,
        state: { propertyIds: true, isAiMonitorBanner: true },
      });
    } else {
      history.push({
        pathname: history.location.pathname,
        state: {
          propertyIds: true,
          isAiMonitorBanner: true,
          isindividual: true,
        },
      });
    }
  };

  const [closeLoader, setCloseLoader] = useState(false);
  const handleBuyerSettlementCompleteCloseApiCall = async () => {
    const propertyId = isBuyerDashboard
      ? buyerDashboardDetails?.property?.propertyId
      : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;
    let input = {
      propertyId: propertyId,
      bannerCode: 'BUYER007',
      bannerHeading: 'AiMonitor complete banner',
    };

    try {
      setCloseLoader(true);

      const response = await postApiCall(POST_BUYER_BANNER_CLOSE, input);

      if (response?.data?.status == 1) {
        setAiBannerClose((prev) =>
          prev.includes(propertyId) ? prev : [...prev, propertyId]
        );
        if (!isBuyerDashboard) {
          groupIt();
        }
        if (isBuyerDashboard) {
          DashboardGroupCall();
        }
      } else {
        console.error('API call unsuccessful:', response);
      }
    } catch (error) {
      console.error('API call failed:', error);
    } finally {
      setCloseLoader(false);
    }
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          width: '100%',
          borderRadius: '20px',
          border: '1px solid #7062E1',
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
          padding: matchesmd && '20px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
        }}
      >
        <Box
          sx={{
            marginTop: matchesmd ? '0' : '25px',
            paddingLeft: matchesmd ? '0' : '67px',
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Typography
            sx={{
              fontWeight: 300,
              fontSize: matchessm ? '14px' : '16px',
              fontFamily: 'poppins',
              textDecoration: 'none',
            }}
          >
            {buyerDashboardDetails?.propertyAddress?.streetName ||
              getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                ?.streetName}
          </Typography>
        </Box>
        <Grid
          container
          direction={'row'}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          {!matchesmd && (
            <Grid
              item
              xs={12}
              md={2}
              lg={1.5}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: matchesmd && '10px',
                marginLeft: !matchessm && '25px',
              }}
            >
              <AiBannerRectangle matchessm={matchessm} matchesmd={matchesmd} />
            </Grid>
          )}
          <Grid item xs={12} md={10} mt={matchesmd ? 2 : 3}>
            {/* Top section - 75% width content */}
            <Box width={matches1300 ? '100%' : '72%'}>
              <Stack direction="column" spacing={matchessm ? 1.5 : 1}>
                {/* Desktop vs mobile layout */}
                {!matchesmd ? (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: matchessm
                        ? '18px'
                        : matchesmd
                        ? '24px'
                        : matches1300 && !isBuyerDashboard
                        ? '24px'
                        : !isBuyerDashboard
                        ? '24px'
                        : '32px',
                      background:
                        'linear-gradient(to bottom right, #6C2AD2, #77CFFE)',
                      backgroundClip: 'text',
                      color: 'transparent',
                      position: 'relative',
                    }}
                  >
                    Ai Monitor - Significant interest detected!
                    <sup
                      style={{
                        position: 'absolute',
                        top: matchessm ? '15px' : '-30px',
                      }}
                    >
                      <img
                        src={AiBannerStar}
                        alt="Start"
                        style={{
                          height: matchessm ? '30px' : '',
                          width: matchessm ? '30px' : '',
                        }}
                      />
                    </sup>
                  </Typography>
                ) : (
                  <Stack direction="row" spacing={1}>
                    <Box>
                      <AiBannerRectangle
                        matchessm={matchessm}
                        matchesmd={matchesmd}
                      />
                    </Box>
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm
                          ? '18px'
                          : matchesmd
                          ? '24px'
                          : '32px',
                        background:
                          'linear-gradient(to bottom right, #6C2AD2, #77CFFE)',
                        backgroundClip: 'text',
                        color: 'transparent',
                        position: 'relative',
                      }}
                    >
                      Ai Monitor - Significant interest detected!
                      <sup
                        style={{
                          position: 'absolute',
                          top: matchessm ? '15px' : '-30px',
                        }}
                      >
                        <img
                          src={AiBannerStar}
                          alt="Start"
                          style={{
                            height: matchessm ? '30px' : '',
                            width: matchessm ? '30px' : '',
                          }}
                        />
                      </sup>
                    </Typography>
                  </Stack>
                )}
                <Typography sx={{ ...poppins300, fontSize: '14px' }}>
                  Interest and activity for{' '}
                  <b style={{ fontWeight: 600, fontFamily: 'poppins' }}>
                    {buyerDashboardDetails?.propertyAddress?.streetName ||
                      getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                        ?.streetName}
                  </b>{' '}
                  has increased and Stage 2 may commence soon.{' '}
                  {(isBuyerDashboard
                    ? buyerDashboardDetails?.stageOneCondition
                        ?.UnconditionalOnly
                    : st1condition?.UnconditionalOnly) === '0' ? (
                    <>
                      To improve your chances of winning the property, now is
                      typically the best time to submit a strong offer and be in
                      an unconditional position.{' '}
                    </>
                  ) : (
                    <>
                      To participate in Stage 2 you will need to be in an
                      unconditional position.{' '}
                    </>
                  )}
                  <a
                    style={{
                      color: '#7062E1',
                      fontWeight: 500,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                  >
                    Learn More
                  </a>
                </Typography>
              </Stack>
            </Box>
            {/* Bottom section - full width */}
            <Grid
              container
              spacing={matchessm && 1}
              sx={{
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: matchessm ? 0 : !isBuyerDashboard ? 6 : 4,
              }}
            >
              <Grid
                item
                sm={12}
                md={3}
                sx={{
                  ...poppins300,
                  fontSize: matchessm ? '12px' : '14px',
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <a
                  style={{
                    color: '#7062E1',
                    fontWeight: 500,
                    fontSize: matchessm ? '14px' : '16px',
                    alignItems: 'center',
                  }}
                >
                  Next Step:
                </a>
                &nbsp;ID Verification &nbsp; <NextStepArrow />
              </Grid>

              <Grid
                item
                sm={12}
                md={9}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: matchessm ? 'space-between' : 'flex-end',
                  paddingRight: !matchessm && '30px',
                  gap: !matchessm && 3,
                  mt: matchessm && 1,
                }}
              >
                <Button
                  onClick={IDVerificationClick}
                  sx={{
                    whiteSpace: 'nowrap',
                    padding: matchessm ? '3px 25px' : '5px 30px',
                    height: matchessm ? '35px' : '42px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: '14px',
                    textTransform: 'none',
                    backgroundColor: '#7062E1',
                    color: '#E6F2FF',
                    '&:hover': {
                      bgcolor: '#7062E1',
                      color: 'white',
                    },
                  }}
                >
                  ID Verification
                </Button>
                <Button
                  disabled={closeLoader}
                  onClick={handleBuyerSettlementCompleteCloseApiCall}
                  sx={{
                    padding: matchessm ? '3px 25px' : '5px 30px',
                    height: matchessm ? '35px' : '42px',
                    width: matchessm ? '120px' : '136px',
                    borderRadius: '5px',
                    ...poppins300,
                    fontSize: '14px',
                    textTransform: 'none',
                    border: '1px solid #7062E1',
                    backgroundColor: 'transparent',
                    color: '#7062E1',
                  }}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export const CongratulationsBanner = (props) => {
  const {
    isBuyerDashboard,
    isWinnerloc,
    signVal,
    depositPaymentStatus,
    getBuyerIndividualValue,
    setBuyerBinderID,
    buyerDashboardDetails,
    PropertyId,
    groupCall,
  } = props;
  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const [openESign, setOpenESign] = useState(false);
  const [pdfMeta, setPdfMeta] = useState(null);
  const params = useParams();
  const dataa = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(dataa);

  const handleCommenceEsignOpen = async () => {
    try {
      const propertyId = isBuyerDashboard
        ? Number(buyerDashboardDetails?.property?.propertyId)
        : params?.propertyId;

      const response = await getApiCall(
        `${REQUEST_SIGN_TEMPLATE}?propertyId=${propertyId}`
      );

      if (response?.data?.status === 1) {
        const { contractFile, fields } = response.data;

        setPdfMeta({
          contractFile,
          fields,
        });

        setOpenESign(true);
      }
    } catch (error) {
      console.error('Failed to fetch sign template', error);
    }
  };

  const HandleSignContractClick = (propertyId) => {
    if (signVal == 'Action Required') {
      if (isBuyerDashboard) {
        history.push({
          pathname: `market/${propertyId}`,
          state: { propertyIds: true, openBoxSignDashboard: true },
        });
      } else {
        history.push({
          pathname: history?.location?.pathname,
          state: { propertyIds: true, openBoxSignDashboard: true },
        });
      }
    } else if (signVal == 'Pending Buyer Signature') {
      if (LOGGED_FROM == 'Mobile') {
        window.open(
          `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${
            buyerDashboardDetails?.binderId ||
            getBuyerIndividualValue?.PropertyDetails?.binderId
          }`,
          '_blank'
        );
      } else {
        handleCommenceEsignOpen();
      }
      setBuyerBinderID('');
    } else {
      if (isBuyerDashboard) {
        history.push({
          pathname: `market/${propertyId}`,
          state: { propertyIds: true, isDepositPaymentBanner: true },
        });
      } else {
        history.push({
          pathname: history?.location.pathname,
          state: { propertyIds: true, isDepositPaymentBanner: true },
        });
      }
    }
  };

  const requestESign = useMemo(() => {
    if (depositPaymentStatus === 'Completed' && signVal === 'Completed') {
      return '4';
    }
    if (signVal === 'Action Required' || signVal === 'Requested') {
      return '1';
    }
    if (signVal === 'Pending Buyer Signature') {
      return '2';
    }
    return '3';
  }, [depositPaymentStatus, signVal]);

  const getButtonContent = () => {
    if (signVal === 'Action Required') {
      return (
        <>
          <SignNowIcon
            disableColor={
              isBuyerDashboard
                ? buyerDashboardDetails?.flagSignContractStatus == null
                : getBuyerIndividualValue?.PropertyDetails
                    ?.flagSignContractStatus == null
            }
          />
          Request E-Sign
        </>
      );
    }
    if (signVal === 'Requested') {
      return (
        <>
          <SignNowIcon
            disableColor={
              isBuyerDashboard
                ? buyerDashboardDetails?.flagSignContractStatus ==
                    'Requested' ||
                  buyerDashboardDetails?.flagSignContractStatus == null
                : getBuyerIndividualValue?.PropertyDetails
                    ?.flagSignContractStatus == 'Requested' ||
                  getBuyerIndividualValue?.PropertyDetails
                    ?.flagSignContractStatus == null
            }
          />
          E-Sign Requested
        </>
      );
    }
    if (signVal === 'Pending Buyer Signature') {
      return (
        <>
          <SignNowIcon />
          Sign Now
        </>
      );
    }
    if (depositPaymentStatus === 'Action Required') {
      return (
        <>
          <DepositIcon />
          Pay Now
        </>
      );
    }
    if (depositPaymentStatus === 'Processing') {
      return (
        <>
          <DepositIcon disableColor={depositPaymentStatus === 'Processing'} />
          Processing...
        </>
      );
    }
    if (depositPaymentStatus === 'Completed') {
      return (
        <>
          <DepositIcon disableColor={depositPaymentStatus === 'Completed'} />
          Payment Completed
        </>
      );
    }
  };

  const isDisabled = (() => {
    if (signVal === 'Pending Buyer Signature') {
      return false;
    } else if (
      (signVal == 'Completed' && depositPaymentStatus === 'Completed') ||
      signVal == 'Requested' ||
      depositPaymentStatus === 'Processing'
    ) {
      return true;
    } else if (
      isBuyerDashboard
        ? buyerDashboardDetails?.flagSignContractStatus == null
        : getBuyerIndividualValue?.PropertyDetails?.flagSignContractStatus ==
          null
    ) {
      return true;
    } else {
      return false;
    }
  })();

  return (
    <>
      <Grid container xs={12} md={12}>
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            padding: matchessm ? '0 0 20px 0' : '10px',
            '.MuiGrid-root': {
              flexGrow: '1',
            },
          }}
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
          }}
        >
          <Grid container xs={12} md={12}>
            <Grid item container xs={12} md={9}>
              <Grid item xs={12}>
                <Stack
                  direction={'column'}
                  padding={matchessm ? '20px 10px 0 10px' : '30px 0 0 33px'}
                >
                  <Typography
                    sx={{
                      fontWeight: 300,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textDecoration: 'none',
                      color: 'rgba(255, 255, 255, 1)',
                    }}
                  >
                    {isWinnerloc ||
                      getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                        ?.streetName}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: !matches450 ? '32px' : '18px',
                      fontWeight: 600,
                      color: 'rgba(255, 255, 255, 1)',
                      fontFamily: 'poppins',
                      mt: !matchessm && '10px',
                    }}
                  >
                    Congratulations! - You have been nominated as Winner!
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      ...poppins300,
                      marginTop: matchessm ? '10px' : '10px',
                      color: 'rgba(255, 255, 255, 1)',
                    }}
                  >
                    You are the nominated WINNER for{' '}
                    <span
                      style={{
                        alignItems: 'center',
                        color: 'rgba(255, 255, 255, 1)',
                        fontWeight: matchessm ? 400 : 700,
                        fontSize: matchessm ? '15px' : '16px',
                        fontFamily: 'poppins',
                        textTransform: 'capitalize',
                      }}
                    >
                      {isWinnerloc ||
                        getBuyerIndividualValue?.PropertyDetails
                          ?.propertyAddress?.streetName}
                      .
                    </span>
                    &nbsp;Please complete the next step to finalise your
                    purchase.
                  </Typography>
                </Stack>
              </Grid>
              <Grid item container xs={12} alignItems={'center'}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  sx={{
                    display: 'flex',
                    justifyContent: matchessm ? 'space-between' : 'start',
                    gap: matchessm ? 1 : 2,
                    padding: matchessm ? '0 20px 0 10px' : '0 0 0 33px',
                  }}
                >
                  <Button
                    sx={{
                      width: matchessm ? 'auto' : '126px',
                      height: matchessm ? '35px' : '42px',
                      borderRadius: '5px',
                      ...poppins300,
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: 'transparent',
                      color: '#E6F2FF',
                      '&:hover': {
                        bgcolor: 'rgb(33, 132, 253)',
                        color: '#E6F2FF',
                      },
                    }}
                  >
                    Terms
                  </Button>
                  <Button
                    disabled={isDisabled}
                    onClick={() => {
                      HandleSignContractClick(PropertyId);
                    }}
                    sx={{
                      minWidth: matchessm ? 'auto' : '125px',
                      gap: matchessm ? '5px' : '10px',
                      height: matchessm ? '35px' : '42px',
                      borderRadius: '5px',
                      ...poppins300,
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: '#FFFFFF',
                      color: '#2184FD',
                      '&:hover': {
                        bgcolor: '#FFFFFF',
                        color: '#2184FD',
                      },
                    }}
                  >
                    {getButtonContent()}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} alignItems={'center'}>
                  <CustomizedSteppers stepValue={requestESign} />
                </Grid>
              </Grid>
            </Grid>
            {!matchesmd && (
              <Grid
                item
                xs={12}
                md={3}
                display={matchessm ? 'none' : 'block'}
                textAlign="center"
                mt={2}
              >
                <img
                  src={BuyerWinnerImage}
                  alt="Stage Two Timer Commenced"
                  style={{
                    objectFit: 'contain',
                    height: '257px',
                    width: '264px',
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Card>
      </Grid>
      {openESign && (
        <CommenceESignDialog
          open={openESign}
          onClose={() => setOpenESign(false)}
          pdfMeta={pdfMeta}
          streetName={
            isBuyerDashboard
              ? buyerDashboardDetails?.propertyAddress?.streetName
              : getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
          }
          matchessm={matchessm}
          userDetail={userDetail}
          propertyId={
            isBuyerDashboard
              ? buyerDashboardDetails?.property?.propertyId
              : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
          }
          getListInfo={groupCall}
        />
      )}
    </>
  );
};

export const WelcomeBanner = () => {
  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const [survey, setSurvey] = useState(false);

  const MyButton = styled(Button)({
    width: '149px',
    gap: '10px',
    borderRadius: '5px',
    ...poppins300,
    fontSize: '14px',
    textTransform: 'none',
    border: '1px solid #E6F2FF',
    backgroundColor: '#FFFFFF',
    color: '#2184FD',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#2184FD',
    },
  });

  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  };
  const onOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (survey) {
      //buyer question get api to filter empty answers
      getApiCall(`${BUYER_GETQUESTION}/0`).then((res) => {
        if (res?.data?.status == 1) {
          const result = res?.data?.buyerQuestions.filter((value) => {
            if (value.questionAnswer != null) {
              return value.questionAnswer == '';
            }
          });
          localStorage.setItem('questions', JSON.stringify(result));
          if (result?.length > 0) {
            history.push('/Buyerfeedback');
          } else {
            toast.info('Survey already completed !', {
              position: 'top-right',
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              progress: 0,
              theme: 'light',
              style: {
                fontFamily: 'Poppins', // 👈 Inline Poppins font
              },
            });
          }
        }
      });
    }
  }, [survey]);

  return (
    <>
      <Grid
        sx={{
          background: 'rgba(33, 132, 253, 0.8)',
          width: '100%',
          borderRadius: '20px',
          '.MuiGrid-root': {
            flexGrow: '1',
          },
          height: matchessm ? '390px' : matchesmd ? '330px' : '300px',
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'end',
        }}
      >
        <Grid
          lg={12}
          md={12}
          sm={12}
          xm={8}
          sx={{
            margin: '0 20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            height: '95%',
            gap: '15px',
            paddingLeft: matchessm ? 0.5 : 3,
          }}
        >
          <Box
            sx={{
              fontSize: !matches450 ? '32px' : '22px',
              fontWeight: 600,
              color: 'rgba(255, 255, 255, 1)',
              fontFamily: 'poppins',
              marginTop: matchessm ? '25px' : '40px',
              textAlign: 'left',
              width: '100%',
            }}
          >
            Get Started with retreX!
          </Box>
          <Box
            sx={{
              fontSize: '14px',
              fontFamily: 'Poppins !important',
              fontWeight: '300',
              color: 'rgba(255, 255, 255, 1)',
              marginRight: matcheslg ? '0px' : '200px',
              marginTop: '10px',
              lineHeight: 'normal',
              textAlign: 'justify',
            }}
          >
            Let retreX assist with your property journey. Answer a few quick
            questions and we’ll build your Profile to help match you with the
            perfect property.
          </Box>
          <Grid
            container
            sx={{
              display: 'flex',
              alignItems: matchessm ? 'end' : 'center',
              justifyContent: 'start',
              marginBottom: matchessm ? '50px' : '20px',
            }}
          >
            <Grid
              item
              sm={6}
              xm={12}
              md={6}
              sx={{
                display: 'flex',
                gap: 3,
                justifyContent: matchessm ? 'space-between' : 'start',
              }}
            >
              <Button
                onClick={onOpen}
                sx={{
                  width: '126px',
                  height: matchessm ? '35px' : '42px',
                  borderRadius: '5px',
                  ...poppins300,
                  fontSize: '14px',
                  textTransform: 'none',
                  border: '1px solid #E6F2FF',
                  backgroundColor: 'transparent',
                  color: '#E6F2FF',
                  '&:hover': {
                    bgcolor: 'rgb(33, 132, 253)',
                    color: '#E6F2FF',
                  },
                }}
              >
                More Info
              </Button>
              <MyButton
                sx={{
                  whiteSpace: 'nowrap',
                  height: matchessm ? '35px' : '42px',
                }}
                onClick={() => {
                  setSurvey(true);
                }}
              >
                <WelcomeBannerFlag /> Finish Profile
              </MyButton>
            </Grid>
          </Grid>
        </Grid>
        {!matcheslg && (
          <Grid
            xl={6}
            lg={6}
            md={6}
            display="flex"
            justifyContent="center"
            alignItems="end"
            sx={{ height: '100%' }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: '381px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'end',
              }}
            >
              <Box
                component="img"
                src={WelcomeBannerImage}
                alt="Welcome"
                sx={{
                  width: '100%',
                  maxHeight: '273px',
                  objectFit: 'contain', // or "cover" depending on the image style
                }}
              />
            </Box>
          </Grid>
        )}
      </Grid>
      <BannerMoreInfoDialog
        open={open}
        onClose={onClose}
        status={'COMPLETE_BUYER_PROFILE'}
      />
    </>
  );
};

export default React.memo(BuyerIndividualBanners);
